import React from 'react'
import { Form, Select, Input, Button } from 'antd'
import { map } from 'lodash-es'

import { scrapingSessionTemplateEditorFormInitialValues } from './initial-values'
import { scrapingSessionTemplateRules } from './rules'
import PropTypes from 'prop-types'

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 21 },
}

const tailLayout = {
  wrapperCol: { offset: 22, span: 2 },
}

const ScrapingSessionTemplateEditorForm = ({
  scrapingSessionTemplate,
  scrapingTagGroups,
  onSubmit,
  isSubmitting,
}) => {
  const initialValues = scrapingSessionTemplateEditorFormInitialValues(
    scrapingSessionTemplate,
  )

  const scrapingTagGroupsOptions = map(scrapingTagGroups, ({ id, name }) => ({
    label: name,
    value: id,
  }))

  return (
    <Form
      initialValues={initialValues}
      onFinish={onSubmit}
      preserve={false}
      scrollToFirstError
      {...layout}
    >
      <Form.Item name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Form.Item label="Session template alias" name="alias">
        <Input />
      </Form.Item>
      <Form.Item label="Session template description" name="description">
        <Input />
      </Form.Item>
      <Form.Item
        label="Tag groups "
        name="tagGroupIds"
        rules={scrapingSessionTemplateRules.tagGroupIds}
      >
        <Select options={scrapingTagGroupsOptions} mode="multiple" />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button type="primary" htmlType="submit" loading={isSubmitting}>
          Save
        </Button>
      </Form.Item>
    </Form>
  )
}

ScrapingSessionTemplateEditorForm.propTypes = {
  scrapingSessionTemplate: PropTypes.object,
  scrapingTagGroups: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
}

ScrapingSessionTemplateEditorForm.defaultProps = {
  scrapingSessionTemplate: undefined,
}

export default ScrapingSessionTemplateEditorForm
